/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Hub_About_Approvers_StarterInputs */



/**
* | output |
* | --- |
* | "The person who starts a run" |
*
* @param {Agent_Hub_About_Approvers_StarterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_about_approvers_starter = /** @type {((inputs?: Agent_Hub_About_Approvers_StarterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_About_Approvers_StarterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Person, die einen Lauf startet")
	return /** @type {LocalizedString} */ ("The person who starts a run")
});